export default {
  // 省份
  province: {
    '北京': '北京市',
    '天津': '天津市',
    '上海': '上海市',
    '重庆': '重庆市',
    '河北': '河北省',
    '河南': '河南省',
    '云南': '云南省',
    '辽宁': '辽宁省',
    '黑龙江': '黑龙江省',
    '湖南': '湖南省',
    '安徽': '安徽省',
    '山东': '山东省',
    '新疆': '新疆维吾尔自治区',
    '江苏': '江苏省',
    '浙江': '浙江省',
    '江西': '江西省',
    '湖北': '湖北省',
    '广西': '广西壮族自治区',
    '甘肃': '甘肃省',
    '山西': '山西省',
    '内蒙古': '内蒙古自治区',
    '陕西': '陕西省',
    '吉林': '吉林省',
    '福建': '福建省',
    '贵州': '贵州省',
    '广东': '广东省',
    '青海': '青海省',
    '西藏': '西藏自治区',
    '四川': '四川省',
    '宁夏': '宁夏回族自治区',
    '海南': '海南省',
    '台湾': '台湾省',
    '香港': '香港特别行政区',
    '澳门': '澳门特别行政区'
  },
  provinceFormat: {
    '北京市': '北京',
    '天津市': '天津',
    '上海市': '上海',
    '重庆市': '重庆',
    '河北省': '河北',
    '河南省': '河南',
    '云南省': '云南',
    '辽宁省': '辽宁',
    '黑龙江省': '黑龙江',
    '湖南省': '湖南',
    '安徽省': '安徽',
    '山东省': '山东',
    '新疆维吾尔自治区': '新疆',
    '江苏省': '江苏',
    '浙江省': '浙江',
    '江西省': '江西',
    '湖北省': '湖北',
    '广西壮族自治区': '广西',
    '甘肃省': '甘肃',
    '山西省': '山西',
    '内蒙古自治区': '内蒙古',
    '陕西省': '陕西',
    '吉林省': '吉林',
    '福建省': '福建',
    '贵州省': '贵州',
    '广东省': '广东',
    '青海省': '青海',
    '西藏自治区': '西藏',
    '四川省': '四川',
    '宁夏回族自治区': '宁夏',
    '海南省': '海南',
    '台湾': '台湾',
    '香港特别行政区': '香港',
    '澳门特别行政区': '澳门'
  },
}
